import { CaseStudyItem, CaseStudySection } from "@/types/case-study";

/**
 * Generate a URL-friendly slug from a title
 */
export const generateSlug = (title: string): string => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
};

/**
 * Validate case study title
 */
export const validateTitle = (title: string): { isValid: boolean; error?: string } => {
  if (!title || title.trim() === '') {
    return {
      isValid: false,
      error: 'Title is required and cannot be empty'
    };
  }
  return { isValid: true };
};

/**
 * Get default case study object
 */
export const getDefaultCaseStudy = (): Omit<CaseStudyItem, 'id' | 'created_at'> => {
  return {
    title: "",
    description: "",
    cover_image: "",
    sections: [],
    status: "draft",
    slug: "",
    seo_title: "",
    seo_description: "",
    og_image: "",
    creation_method: "manual",
  };
};

/**
 * Check if title is valid for enabling/disabling save buttons
 */
export const isTitleValid = (title: string): boolean => {
  return title && title.trim() !== '';
};

/**
 * Filter out empty sections for display purposes
 */
export const filterEmptySections = (sections: CaseStudySection[]): CaseStudySection[] => {
  return sections.filter(section => {
    // Check if section has content
    const hasContent = section.content && section.content.trim() !== '';
    
    // Check if section has images
    const hasImages = section.images && section.images.length > 0;
    
    // Check if section has content blocks
    const hasContentBlocks = section.content_blocks && section.content_blocks.length > 0;
    
    return hasContent || hasImages || hasContentBlocks;
  });
};
